import React, { 
  useEffect,
  useRef,
  useState,
} from 'react'
import { 
  useDispatch,
  useSelector
} from 'react-redux'
import { 
  useNavigate,
  Link as RouterLink
} from 'react-router-dom'

import { 
  LockOutlined as LockOutlinedIcon 
} from '@mui/icons-material'
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Avatar,
  Grid,
  Link,
} from '@mui/material'

import {
  setFlashNotice,
  setFlashAlert,
  clearFlashNotice,
  clearFlashAlert
} from '../../redux/features/ui/uiSlice'

import {
  selectAuthToken,
  setAuthToken
} from '../../redux/features/user/userSlice'

import { formatDeviseErrors } from './deviseErrors'
import { deviseFetch, showFailedRequest } from './deviseRequest'

const classes = {
  link: {
    margin: '0 5px 0 5px',
    cursor: 'pointer',
  }
}

export default function ConfirmSignUp() {
  const navigate = useNavigate()
  const dispatch = useDispatch()  
  const storedAuthToken = useSelector(selectAuthToken)
  const confirmationAttempted = useRef(false)
  const csrfToken = storedAuthToken || document.querySelector('meta[name=csrf-token]')?.content || ''
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (!storedAuthToken) {
      const documentAuthToken = document.querySelector('meta[name=csrf-token]')?.content
      if (documentAuthToken) {
        dispatch(setAuthToken(documentAuthToken))
      }
    }
  }, [dispatch, storedAuthToken])

  useEffect(() => {
    if (confirmationAttempted.current) {
      return
    }

    confirmationAttempted.current = true

    const confirmUser = async () => {
      const confirmationToken = new URLSearchParams(window.location.search)
        .get('confirmation_token')

      if (!confirmationToken) {
        return
      }

      const csrfToken = document.querySelector(
        'meta[name=csrf-token]')?.content || ''

      try {
        const result = await deviseFetch(
          dispatch,
          `/user/confirmation.json?confirmation_token=${
            confirmationToken
          }`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
          },
        })

        // The server didn't answer, or answered with something unexpected:
        // say so and offer the resend page.
        if (result.failure) {
          showFailedRequest(dispatch, result)
          navigate('/app/resend_confirmation')
          return
        }
        const { response, json: json_data } = result

        console.log(response.status)
        console.log(json_data)

        if (response.status === 200){
          console.log('confirmation succeeded')

          dispatch(setFlashNotice('Confirmation succeeded. You can now log in'))
          navigate('/app/sign_in')
          return 
        }
        else if (response.status === 422){
          console.log('could not confirm')
          console.log(json_data)
          setErrors(json_data?.errors ?? {})

          // The typical error is that the token is invalid. Otherwise show
          // what the server said (e.g. the email was already confirmed).
          const tokenErrors = json_data?.errors?.confirmation_token
          const alertMessage = tokenErrors?.includes('is invalid')
            ? 'The confirmation link was invalid. Enter your email address below to send a new link.'
            : formatDeviseErrors(json_data)

          dispatch(setFlashAlert(alertMessage))
          navigate('/app/resend_confirmation')
          return
        }

        dispatch(setFlashAlert(formatDeviseErrors(json_data)))
        navigate('/app/resend_confirmation')
      } 
      catch (error) {
        console.error(error)
        dispatch(setFlashAlert(formatDeviseErrors(null)))
        navigate('/app/resend_confirmation')
      }
    }

    confirmUser()

  }, [])

  const handleLinkClick = (e) => {
    dispatch(clearFlashNotice())
    dispatch(clearFlashAlert())
  }

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 9,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>

        <Typography component='h1' variant='h5'>
          Processing Confirmation
        </Typography>
      </Box>
    </Container>
  )
}
